export enum LessonEvent {
  NAVIGATE_HOME = 'navigateHome',
  FINISH_LESSON = 'finishLesson',
  TOGGLE_INDEX = 'toggleIndex',
  REQUEST_USER_INFO = 'requestUserInfo',
  SEND_USER_INFO = 'sendUserInfo',
  REQUEST_LESSON_INFO = 'requestLessonInfo',
  SEND_LESSON_INFO = 'sendLessonInfo',
  REFERRAL_BUTTON_CLICKED = 'referralButtonClicked',
  OPEN_CHAT_BOT = 'openChatBot',
  START_CHAT_BOT = 'startChatBot',
  SEND_CHAT_BOT_LESSON_INFO = 'sendChatBotLessonInfo',
}

export enum ActivityPlayerEvent {
  LESSON_COMPLETE = 'lessonComplete',
  ACTIVITY_COMPLETE = 'activityComplete',
  SLIDE_CHANGED = 'slideChanged',
}
